import { render, staticRenderFns } from "./_providerWinLoseOperatorPt.vue?vue&type=template&id=74b2d58f&lang=pug"
import script from "./_providerWinLoseOperatorPt.vue?vue&type=script&lang=js"
export * from "./_providerWinLoseOperatorPt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports